/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Warm_Calf_CallInputs */

const en_cool_warm_calf_call = /** @type {(inputs: Cool_Warm_Calf_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage access to user's goals`)
};

const de_cool_warm_calf_call = /** @type {(inputs: Cool_Warm_Calf_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf Ziele des Benutzers verwalten`)
};

/**
* | output |
* | --- |
* | "Manage access to user's goals" |
*
* @param {Cool_Warm_Calf_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_warm_calf_call = /** @type {((inputs?: Cool_Warm_Calf_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Warm_Calf_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_warm_calf_call(inputs)
	return de_cool_warm_calf_call(inputs)
});